import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import {AssetService} from "../../services/AssetService";

export class ReportLowBatteryModel {
    static $inject = ['$q','FileSaver','Blob','AssetService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    tagsToReport:number = 10;
    availableTagsToReport:number[] = [5,10,20,40,80,160,240,580];
    totalCount:number = 0;
    constructor(public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public assetService:AssetService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
    }
    getReport():ng.IPromise<any>{
        return this.assetService.getBatteryLevelReport(this.tagsToReport).then((data)=>{
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'VTag_Battery_Levels.xlsx');
        })
            .catch((exc)=>{
                this.notifyService.notify("getReport err:"+exc);
            });
        return this.$q.when();
    }
}
